<template>
  <div class="olympicMusicShowRecords">
    <van-list class="cell_ul"
      v-model="loading"
      :finished="finished"
      finished-text="没有更多了"
      @load="getList"
    >
      <div class="cell_item"
        v-for="item in list"
        :key="item.id"
        @click="navToRecord(item)"
      >
        <div class="header">
          <span class="text1">{{item.competition ? item.competition.name : ''}}</span>
          <span class="text2">{{item.statusText}}</span>
        </div>
        <div class="main">
          <div class="left">
            <div class="text">报名单号： {{item.id}}</div>
            <div class="text" v-if="item.isSingle">参赛人： {{item.contestants.length > 0 ? item.contestants[0].realName : ''}}</div>
            <div class="text" v-else>团队名称： {{item.teamName}}</div>
            <div class="text">参赛类型： {{item.entryType ? item.entryType.name : ''}}</div>
            <div class="text">组别： {{item.entryGroup ? item.entryGroup.name : ''}}</div>
            <div class="text">报名时间： {{item.createTime}}</div>
          </div>
          <div class="right">
            <span class="text">详情</span>
            <van-icon name="arrow" size="20" />
          </div>
        </div>
      </div>
    </van-list>
  </div>
</template>

<script>
import { Icon, List } from 'vant'

import { ApiQuerySignupRecords } from '@/api/olympicMusicShow.js'

export default {
  name: 'olympicMusicShowRecords',
  components: {
    vanIcon: Icon,
    vanList: List,
  },
  data() {
    return {
      list: [],
      loading: false,
      finished: false,
      page: 1,
      size: 10
    }
  },
  computed: {
    userInfo() {
      return this.$store.state.index.userInfo
    },
    competitionId() {
      return this.$store.state.olympicMusicShow.competitionId
    }
  },
  mounted() {
    document.title = '我的赛程'
  },
  methods: {
    getList() {
      if (this.finished) return false

      let params = {
        UserId: this.userInfo.userId,
        CompetitionId: this.competitionId,
        PageNo: this.page,
        PageSize: this.size
      }

      ApiQuerySignupRecords(params).then(res => {
        this.loading = false
        if (res.code === 200) {
          let results = res.data.results

          if (results.length < this.size) {
            this.finished = true
          } else {
            this.page++
          }

          if (this.page === 1) {
            this.list = results
          } else {
            this.list = this.list.concat(results)
          }
        }
      })
    },
    navToRecord(item) {
      this.$router.push({ path: 'record', query: { id: item.id } })
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/css/flexable.scss';

.olympicMusicShowRecords {
  width: 100%;
  min-height: 100vh;
  background-color: #F5F5F9;
  .cell_ul {
    width: 100%;
    padding: px2rem(30) px2rem(20);
    box-sizing: border-box;
    .cell_item {
      margin-bottom: px2rem(20);
      width: 100%;
      padding: px2rem(30) px2rem(20);
      border-radius: px2rem(8);
      background-color: #fff;
      box-sizing: border-box;
      .header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: px2rem(40);
        line-height: 1;
        font-size: px2rem(32);
        font-weight: bold;
        color: #1F1F1F;
      }
      .main {
        display: flex;
        align-items: center;
        justify-content: space-between;
        .left {
          .text {
            display: block;
            margin-bottom: px2rem(27);
            text-align: left;
            line-height: 1;
            font-size: px2rem(30);
            font-weight: 500;
            color: #585858;
            &:last-child {
              margin-bottom: 0;
            }
          }
        }
        .right {
          display: flex;
          align-items: center;
          .text {
            margin-right: px2rem(6);
            line-height: 1;
            font-size: px2rem(30);
            font-weight: 500;
            color: #585858;
          }
        }
      }
    }
  }
}
</style>